module.exports = __webpack_public_path__ + "static/rocket-b7ba745b7efde3d4df74ce54bc77ebd6.svg";